import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const aasClient = axios.create({
  baseURL: API_BASE_URL
});

const validateToken = (token) => {
  if (!token) {
    console.error('[AasAPI] No authentication token provided');
    throw new Error('Authentication required. Please log in.');
  }
  const parts = token.split('.');
  if (parts.length !== 3) {
    console.error('[AasAPI] Invalid token format');
    throw new Error('Invalid authentication token. Please log in again.');
  }
  return true;
};

export const createAasSession = async (ticketId, token) => {
  try {
    validateToken(token);
    const response = await aasClient.post('/aas/sessions', { ticketId }, {
      headers: { 'x-auth-token': token }
    });
    return response.data;
  } catch (error) {
    console.error('[AasAPI] createAasSession error:', error);
    throw error;
  }
};

export const getActiveAasSession = async (ticketId, token) => {
  try {
    validateToken(token);
    const response = await aasClient.get(`/aas/sessions/active/${ticketId}`, {
      headers: { 'x-auth-token': token }
    });
    return response.data;
  } catch (error) {
    console.error('[AasAPI] getActiveAasSession error:', error);
    throw error;
  }
};

export const sendAasMessage = async (sessionId, message, token) => {
  try {
    validateToken(token);
    const response = await aasClient.post(`/aas/sessions/${sessionId}/message`, {
      message
    }, {
      headers: { 'x-auth-token': token },
      timeout: 60000 // 60s timeout — agent may take time to process
    });
    return response.data;
  } catch (error) {
    console.error('[AasAPI] sendAasMessage error:', error);
    throw error;
  }
};

export const closeAasSession = async (sessionId, token) => {
  try {
    validateToken(token);
    const response = await aasClient.post(`/aas/sessions/${sessionId}/close`, {}, {
      headers: { 'x-auth-token': token }
    });
    return response.data;
  } catch (error) {
    console.error('[AasAPI] closeAasSession error:', error);
    throw error;
  }
};

export const submitAasFeedback = async (sessionId, data, token) => {
  try {
    validateToken(token);
    const response = await aasClient.post(`/aas/sessions/${sessionId}/feedback`, data, {
      headers: { 'x-auth-token': token }
    });
    return response.data;
  } catch (error) {
    console.error('[AasAPI] submitAasFeedback error:', error);
    throw error;
  }
};
